/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CookieConsentCustomerDto } from '../../models/cookie-consent-customer-dto';
import { Response } from '../../models/response';

export interface ApiIdentityCookieconsentPut$Plain$Params {
      body?: CookieConsentCustomerDto
}

export function apiIdentityCookieconsentPut$Plain(http: HttpClient, rootUrl: string, params?: ApiIdentityCookieconsentPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityCookieconsentPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiIdentityCookieconsentPut$Plain.PATH = '/api/identity/cookieconsent';
